import { render, staticRenderFns } from "./SectionTextStyle.vue?vue&type=template&id=3386c648&"
import script from "./SectionTextStyle.vue?vue&type=script&lang=js&"
export * from "./SectionTextStyle.vue?vue&type=script&lang=js&"
import style0 from "./SectionTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports